export function GetUserClassificationName(orgInfo, userInfo) {
    var groupId = 0;
    if (orgInfo) {
        groupId = orgInfo.primaryGroupId;
    }
    switch (groupId) {
        case 83298:
            return 'Bookseller'
        case 83300:
            return 'Librarian'
        case 83299:
            return 'Chain Retailer'
        case 83302:
            return 'Media'
        case 83301:
            return 'Wholesaler'
        case 83303:
        default:
            var classification = userInfo.userType ? userInfo.userType : 'Unknown';
            return classification
    }
}

export function GetOrgClassificationNameOrgLevel(groupId, userInfo) {
    switch (groupId) {
        case 83298:
            return 'Indie Bookstore';
        case 83303:
            return userInfo.userType ? userInfo.userType : 'Unknown';
        case 83300:
            return 'Library';
        case 83299:
            return 'Chain Retailer';
        case 83302:
            return 'Media';
        case 83301:
            return 'Wholesaler';
        default:
            return '';
    }
}